import {
  TextInput,
  FormLabel,
  FormControl,
  Button,
  Select,
  H3,
} from '@ouster/webviz-react-components';

import { FormEvent } from 'react';

import styles from './Organization.module.css';
import { UserRole } from '../../types';
import { ROLES } from '../../utils/constants';

type InviteMemberProps = {
  inviteHandler: (
    data: {
      email: string;
      role: UserRole;
    },
    onSuccess: () => void
  ) => void;
  isOusterUser: boolean;
};

export default function InviteMember({
  inviteHandler,
  isOusterUser,
}: InviteMemberProps) {
  const availableRoles = isOusterUser
    ? ROLES
    : ROLES.filter((role) => role !== 'SUPPORT');

  function resetForm() {
    const form = document.getElementById('invite-form') as HTMLFormElement;
    form.reset();
  }

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const email = formData.get('email') as string;
    const role = formData.get('role') as UserRole;

    if (!email || !role) return;

    inviteHandler({ email, role }, resetForm);
  }

  return (
    <div className={styles['section-container']} data-testid="invite-member-root">
      <H3 fontSize={16} textTransform="uppercase" className={styles.heading}>
        Invite Members
      </H3>
      <form onSubmit={handleSubmit} id="invite-form" data-testid="invite-member-form">
        <FormControl paddingInline={0}>
          <FormLabel>Invitee Email (one at a time)</FormLabel>
          <div className={styles['invite-form']}>
            <TextInput
              type="email"
              isRequired
              name="email"
              flex={1}
              placeholder="invitee@email.com"
              data-testid="invite-member-email-input"
            />
            <Select
              placeholder="Select invitee's role"
              isRequired
              textTransform="capitalize"
              name="role"
              data-testid="invite-member-role-select"
            >
              {availableRoles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </Select>
            <Button variant="outline" minWidth={150} type="submit" data-testid="invite-member-submit-btn">
              Send Invitation
            </Button>
          </div>
        </FormControl>
      </form>
    </div>
  );
}
